import "./Takeourword.scss"
import { useNavigate } from 'react-router-dom';

const testimonials = [
  {
    image: '/images/im1.webp',
    title: 'Implemented end to end Customer transactional journey (Presales, Sales, Post sales and customer portal) on Salesforce for a leading Real Estate customer based out of Hyderabad.',
  },
  {
    image: '/images/im2.webp',
    title: 'We implemented Warranty Management, Post Sales Service, spare parts & Inventory management for a leading Two-Wheeler EV manufacturer from India.',
  },
  {
    image: '/images/im3.webp',
    title: 'We implemented for a large quasi government Non-Profit organization based out of New Delhi, their entire multiyear Grants management program with multiple modules viz, Applicants module, Reviewers module and the entire Grants management module.',
  
  },
];

export default function TakeOurword({data=[]}) {
  const navigate= useNavigate()
  return (
    <div className="wrapper">
      <div className="containers">
        <div className="mainBox">
          <h2 className="heading">
            Don't Just Take Our Word For It. See Their Results.
          </h2>

          <div className="grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="card">
                <div className="imageWrapper">
                   <img  loading="lazy"
                    src={testimonial.image}
                    alt={`Testimonial ${index + 1}`}
                  className="takeourword-image"
                  />
                </div>
                <div className="cardContent">
                  <p className="description">{testimonial.title}</p>
                 <button
                      className="readMoreBtn"
                      onClick={() =>
                        navigate("/talktoexpert", {
                          state: {
                            image: testimonial.image,
                            title: testimonial.title,
                            headinds: testimonial.headinds,
                            fromCard: true 
                          },
                        })
                      }
                    >
                      Read more <span className="arrow">›</span>
                    </button>
                </div>
              </div>
            ))}
          </div>

          <div className="buttonWrapper">
            <button className="viewMoreBtn" onClick={()=>navigate("/totalcards")}>VIEW MORE</button>
          </div>
        </div>
      </div>
    </div>
  );
}

